module.exports = __webpack_public_path__ + "img/b767f8c.jpg";